import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Camera20Regular, ChevronRightRegular, CloudFlow20Regular, Key20Regular, PersonRegular, SignOutRegular, SparkleRegular } from '@fluentui/react-icons';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NavigationTile from '@ui/components/common/NavigationTile';
import useSettingsStyles from './useSettingsStyles';
const Settings = (props) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isLightMode = theme.palette.mode === 'light';
    const { sectionStyles, statusInfoContainerStyles, statusCardStyles, settingsContainerStyles, navigationTilesContainerStyles, logoutButtonStyles } = useSettingsStyles();
    const statusInfoCards = [
        {
            id: 0,
            icon: _jsx(Camera20Regular, { color: theme.palette.common.white }),
            label: 'Camera',
            color: theme.palette.common.white,
            bgColor: theme.palette.success.main
        },
        {
            id: 1,
            icon: _jsx(Key20Regular, { color: theme.palette.common.white }),
            label: 'VPN',
            color: theme.palette.common.white,
            bgColor: theme.palette.error.main
        },
        {
            id: 2,
            icon: _jsx(CloudFlow20Regular, { color: theme.palette.common.black }),
            label: 'API',
            color: theme.palette.common.black,
            bgColor: theme.palette.warning.main
        }
    ];
    const settings = {
        general: [
            {
                preIcon: PersonRegular,
                preIconSize: 20,
                preIconColor: theme.palette.text.primary,
                PostIcon: ChevronRightRegular,
                postIconsize: 10,
                postIconcolor: theme.palette.text.primary,
                name: 'Account Information',
                path: '/settings/account-information'
            },
            {
                preIcon: SparkleRegular,
                preIconSize: 20,
                preIconColor: theme.palette.text.primary,
                PostIcon: ChevronRightRegular,
                postIconsize: 10,
                postIconcolor: theme.palette.text.primary,
                name: 'Appearance',
                path: '/settings/appearance'
            }
            // {
            //   preIcon: LocalLanguageRegular,
            //   preIconSize: 20,
            //   preIconColor: theme.palette.text.primary,
            //   PostIcon: ChevronRightRegular,
            //   postIconsize: 10,
            //   postIconcolor: theme.palette.text.primary,
            //   name: 'Language',
            //   path: '/settings/language'
            // }
        ],
        support: [
        // {
        //   preIcon: WarningRegular,
        //   preIconSize: 20,
        //   preIconColor: theme.palette.text.primary,
        //   PostIcon: ChevronRightRegular,
        //   postIconsize: 10,
        //   postIconcolor: theme.palette.text.primary,
        //   name: 'Report an Issue',
        //   path: ""
        // },
        // {
        //   preIcon: QuestionCircleRegular,
        //   preIconSize: 20,
        //   preIconColor: theme.palette.text.primary,
        //   PostIcon: ChevronRightRegular,
        //   postIconsize: 10,
        //   postIconcolor: theme.palette.text.primary,
        //   name: 'FAQs',
        //   path: ""
        // }
        ]
    };
    const baseURL = process.env.REACT_APP_API_URL;
    const frontEndUrl = process.env.FRONT_END_APP_URL;
    const handleLogout = () => {
        // clear token, cookies etc.
        // any other operations on logout.
        window.location.href = `${baseURL}/auth/logout?redirectUrl=${frontEndUrl}`;
    };
    const handleNavigationTileClick = (path) => {
        navigate(path);
    };
    return (_jsxs(Box, { id: 'page-settings', className: 'settings', sx: sectionStyles, children: [_jsx(Box, { className: 'status-info-container', sx: statusInfoContainerStyles }), _jsx(Typography, { variant: 'subtitle1', color: 'textSecondary', children: "General" }), Object.entries(settings).map(([sectionTitle, sectionItems]) => (_jsx(Box, { className: 'settings-section', sx: settingsContainerStyles, children: _jsx(Box, { className: 'navigation-tiles-section', sx: navigationTilesContainerStyles, children: sectionItems.map((setting) => (_jsx(NavigationTile, { PrefixIcon: setting.preIcon, prefixIconsize: setting.preIconSize, prefixIconcolor: setting.preIconColor, PostfixIcon: setting.PostIcon, postfixIconsize: setting.postIconsize, postfixIconcolor: setting.postIconcolor, name: setting.name, onClick: () => handleNavigationTileClick(setting.path) }, `setting-tile-${setting.name}`))) }) }, sectionTitle))), _jsx(Box, { mb: 6, children: _jsx(Button, { className: 'logout-btn', size: 'medium', fullWidth: true, sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        textTransform: 'none',
                        gap: 1
                    }, startIcon: _jsx(SignOutRegular, { fontSize: 20 }), onClick: handleLogout, color: 'error', variant: 'soft', children: "Logout" }) })] }));
};
export default Settings;
